import React, { useEffect, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box, Typography } from '@mui/material'

import { CollapsibleTable } from '../../../../ui'
import { ObservationsDialog } from './components'
import { useAppContext } from '../../contexts'
import { useCombos } from '../../../combos/hooks'
import { renderLoading } from '../../../../core/utils'
import { APP_TASK_TABLE_CONFIG, canViewSSPPStates } from './constants'
import { useTaskProcessing } from './hooks'

export const AppTaskTable = () => {
  const intl = useIntl()
  const combos = useCombos(['tipologias_tareas', 'estados_sspp', 'subtipologias_tareas'])
  const { application, getAppTasks, tasks } = useAppContext()
  const role = useSelector((state) => state.global.role)
  const permissions = useSelector((state) => state.global.permissions) || {}

  const [loading, setLoading] = useState(true)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [selectedObservations, setSelectedObservations] = useState('')

  const canViewInternalStates = useMemo(() => {
    return canViewSSPPStates(role, permissions)
  }, [role, permissions])

  const handleOpenObservations = (observaciones_sspp) => {
    setSelectedObservations(observaciones_sspp)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setSelectedObservations('')
  }

  const tasksData = tasks || []

  const processedTasks = useTaskProcessing(
    tasksData,
    combos,
    canViewInternalStates,
    handleOpenObservations
  )

  useEffect(() => {
    if (application?.id) {
      getAppTasks()
        .then(() => {
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [application]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return renderLoading()
  }

  if (!processedTasks || processedTasks.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        minHeight="60px"
        bgcolor="transparent"
        borderRadius="1px"
        py={1}
        px={3}
      >
        <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
          {intl.formatMessage({ id: 'pages.application.detail.history.noTasks' })}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <CollapsibleTable config={APP_TASK_TABLE_CONFIG(intl)} data={processedTasks} />

      <ObservationsDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        observaciones_sspp={selectedObservations}
      />
    </>
  )
}
